module.exports = __webpack_public_path__ + "static/iwanttobuildthis-0d31ffca9d34ec904e05fb4f24ced406.png";